import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPostJson } from './client'

/**
 * ADM -> Displays, calea noua. Perechile vechi, din
 * `application/controllers/Adm.php`:
 *
 *   wallboards()         -> GET  /adm/wallboards
 *   saveWallboard()      -> POST /adm/wallboards
 *   revokeWallboard($id) -> POST /adm/wallboards/{id}/revoke
 *
 * Calea NU poarta `/api/v2`: il pune `apiGet`.
 *
 * RETRAGEREA E UN POST, nu un DELETE: tabla nu se sterge, i se stinge randul -
 * ca jetonul sa nu mai poata fi emis vreodata si ca urma de audit sa duca
 * undeva.
 */

export interface WallboardOption {
  key: string
  label: string
}

export interface WallboardCompany {
  id: number
  name: string
}

export interface Wallboard {
  id: number
  name: string
  /** Adresa insasi e cheia - de-aia e lunga si de-aia se poate retrage. */
  token: string
  view: number
  viewLabel: string
  theme: string
  themeLabel: string
  refreshSeconds: number
  /** 0 inseamna „toate firmele" - parcul intreg al furnizorului. */
  companyId: number
  companyName: string
  tiles: string[]
  chart: string
  lastSeenAt: string
  createdAt: string
}

export interface WallboardsScreen {
  pageTitle: string
  pageHeader: string
  breadcrumbs: string[]
  boards: Wallboard[]
  /** Numai firmele omului: nu se poate emite o cheie pentru altcineva. */
  companies: WallboardCompany[]
  /** „Toate firmele" se ofera numai cui chiar le vede pe toate. */
  canPickEveryCustomer: boolean
  views: WallboardOption[]
  themes: WallboardOption[]
  /** Cheie de vedere („1", „2", „3") -> ce cifre poate arata. */
  catalogues: Record<string, WallboardOption[]>
  defaults: Record<string, string[]>
  charts: Record<string, WallboardOption[]>
  maxTiles: number
}

export interface WallboardSaved {
  status: string
  message: string
  id?: number
  token?: string
}

export interface WallboardDraft {
  ID: number
  name: string
  view: number
  company_id: number
  tiles: string[]
  chart: string
  theme: string
  refresh_seconds: number
}

export function wallboardsQuery() {
  return queryOptions({
    queryKey: ['adm', 'wallboards'],
    queryFn: () => apiGet<WallboardsScreen>('/adm/wallboards'),
  })
}

export function saveWallboard(draft: WallboardDraft): Promise<WallboardSaved> {
  return apiPostJson<WallboardSaved>('/adm/wallboards', draft)
}

export function revokeWallboard(id: number): Promise<WallboardSaved> {
  return apiPostJson<WallboardSaved>(`/adm/wallboards/${id}/revoke`, {})
}
